import { FaUser } from "react-icons/fa";
import { RiOrganizationChart } from "react-icons/ri";
import { FiUser } from "react-icons/fi";
import useEmployeeHook from "../../../hooks/useEmployeeHook";
import { useStateSetter } from "../../../hooks/statehooks/UseStateSettersHook";
import { onGetSubordinates } from "../../../services/employee";
import { useEffect, useState } from "react";
import { useStateGetter } from "../../../hooks/statehooks/UseStateGettersHook";
import { toast } from "react-toastify";
import usePositionHook from "../../../hooks/usePositionHook";

const VerticalLine = ({ length }: any) => (
  <div
    className={` block border border-gray-700 h-[100px] bg-black  w-[1px]`}
  ></div>
);

const EmplItem = ({ item }: any) => {
  const [subordinates, setsubordinates] = useState([]);
  const { allorgPositions } = usePositionHook();
  const { selectedEmployee, config } = useStateGetter();
  const getSubs = async () => {
    try {
      //  setLoading(true);

      var response = await onGetSubordinates(item.id, config);
      setsubordinates(response.data);
    } catch (e: any) {
      toast.error(e);
    } finally {
      // setLoading(false);
    }
  };

  useEffect(() => {
    getSubs();
  }, []);

  return (
    <div className="flex flex-col justify-center items-center  min-w-[200px] ">
      <div className="bg-white rounded-md flex justify-between p-3  scale-75">
        <FiUser size={40} className="bg-faintBlue rounded-full p-2 " />
        <div className="mx-2">
          <p className="text-textbg text-sm font-semibold">
            {item.firstName} {item.lastName}
          </p>
          <p className="text-textbg text-xs font-light ">
            {
              allorgPositions.filter((l) => l.id != item.positionID)[0]
                ?.positionTitle
            }
          </p>
        </div>
        <p className="text-gray-700 inline text-xs">
          <RiOrganizationChart className="inline" size={20} />
          {subordinates.length}{" "}
        </p>
      </div>
      <VerticalLine length={"100px"} />

      <div className="grid grid-cols-5 border-t gap-10  border-gray-500">
        {subordinates.map((item: any) => (
          <SubEmplItem item={item.subordinate} />
        ))}
      </div>
    </div>
  );
};

const SubEmplItem = ({ item }: any) => {
  const [subordinates, setsubordinates] = useState([]);
  const { allorgPositions } = usePositionHook();
  const { selectedEmployee, config } = useStateGetter();

  return (
    <div className="  flex-col justify-center items-center  min-w-[200px] block ">
      <div className="bg-white rounded-md flex justify-between p-3 shadow  scale-50">
        <FiUser size={40} className="bg-faintBlue rounded-full p-2 " />
        <div className="mx-2">
          <p className="text-textbg text-sm font-semibold">
            {item.firstName} {item.lastName}
          </p>
          <p className="text-textbg text-xs font-light ">
            {
              allorgPositions.filter((l) => l.id != item.positionID)[0]
                ?.positionTitle
            }
          </p>
        </div>
        <p className="text-gray-700 inline text-xs">
          <RiOrganizationChart className="inline" size={20} />
          {subordinates.length}{" "}
        </p>
      </div>
      {/* <VerticalLine length={"100px"} />

      <div className="    border-t border-gray-500 gap-10 w-[600px] ">
        {subordinates.map((item: any) => (
          <SubEmplItem item={item.subordinate} />
        ))}
      </div> */}
    </div>
  );
};

export default () => {
  const { setLoading } = useStateSetter();
  const { selectedOrgEmployees } = useEmployeeHook();

  return (
    <div className="flex justify-start items-start overflow-y-scroll overflow-x-scroll gap-2 bg-[#FCFCFD] h-full py-4">
      {selectedOrgEmployees
        .filter((g) => g.isLineManager)
        .map((item) => (
          <EmplItem item={item} />
        ))}
    </div>
  );
};
